import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterApplyTemplateOptions, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import AtividadeService from "service/gestao/atividades/AtividadeService";
import { TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const atividadeService = new AtividadeService();

export default function AtividadeListagem() {

    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        cobranca: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    const matchModeOptions = [
        { label: 'Igual', value: FilterMatchMode.EQUALS },
        { label: 'Diferente', value: FilterMatchMode.NOT_EQUALS }
    ]

    const filterApplyTemplate = (options: ColumnFilterApplyTemplateOptions) => {
        return <Button type="button" label="Aplicar" onClick={options.filterApplyCallback} ></Button>;
    };

    const representativeFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={atividadeService.getCobrancaFilter()}
            onChange={(e: DropdownChangeEvent) => {
                options.filterCallback(e.value);
            }}
            optionLabel="label" optionValue="value" placeholder="Qualquer" className="p-column-filter"
        />;
    };

    return (

        <BaseListagem ordenacao="nome,ASC" service={atividadeService} urlService="/atividade" tituloPagina={'Atividades'} defaultFilters={defaultFilters} showClearFilterButton>
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="cobranca" header="Cobrança" body={(data) => data.cobranca ? 'Sim' : 'Não'} filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={matchModeOptions} filterApply={filterApplyTemplate} filterElement={representativeFilterTemplate} />
        </BaseListagem>
    )
}
